<template>
  <div id="homepage">
    <Header></Header>
    <Solid></Solid>
    <div class="leftpadding">
      <div>
        <Cardtitle msg="基本信息"></Cardtitle>
        <div>
          <div class="cardbox">
            <a-row>
              <a-col :md="{ span: 6 }" :xs="{ span: 24 }">
                <Cardinfo></Cardinfo>
              </a-col>
              <a-col :md="{ span: 6 }" :xs="{ span: 24 }">
                <div class="flex">
                  <a-button type="danger" @click="gostuscore" shape="round"
                    >查看受训人员成绩</a-button
                  >
                  <div class="bookbox">
                    <a-button
                      class="bookbtn"
                      shape="round"
                      @click="centerDialogVisible = true"
                      type="primary"
                      round
                      >预约训练</a-button
                    >
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- </a-col> -->
        <!-- </a-row> -->
      </div>
      <!-- 训练记录 -->
      <div>
        <div class="titleText">演练记录</div>
        <a-row>
          <a-col :md="{ span: 24, offset: 0 }">
            <div class="tablebox">
              <a-table
                :columns="columns"
                :data-source="tableData"
                :pagination="false"
                rowKey="index"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="seedetails(record)">查看详情</a>
                </span>
              </a-table>
              <!-- <br />
              <hr />
              <br /> -->
              <!-- 测试 -->
              <!-- <a-table
                :columns="traincolumns"
                :data-source="trainlist"
                :pagination="pagination"
                rowKey="index"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="seedetails(record)">查看详情</a>
                </span>
              </a-table> -->
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 预约弹框 -->
    <a-modal
      title="预约下次训练"
      @cancel="closeappoint"
      :maskClosable="true"
      :visible.sync="centerDialogVisible"
      center
    >
      <!-- width="30vw" -->
      <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>联系方式：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input v-model="bookinfo.iphone" placeholder="请输入您的联系方式" />
        </a-col>
      </a-row>
      <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>联系人：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input v-model="bookinfo.linkMan" placeholder="请输入联系人姓名" />
        </a-col>
      </a-row>

      <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>单位全称：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input type="text" v-model="bookinfo.universityName" />
          <!-- {{  }} -->
        </a-col>
      </a-row>
      <!-- <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>部门：</span>
        </a-col> -->
      <!-- <a-col :span="15" class="inputs">
          <a-select
            class="departselect"
            v-model="bookinfo.departmentName"
            style="width: 100%"
            @change="handdepartChange"
          >
            <a-select-option
              class="depart"
              v-for="item in departlist"
              :key="item.id"
              :value="item.departmentName"
              >{{ item.departmentName }}</a-select-option
            >
          </a-select>
        </a-col> -->
      <!-- </a-row> -->
      <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>培训时间：</span>
        </a-col>
        <a-col
          :xs="{ span: 15, offset: 0 }"
          :md="{ span: 15, offset: 0 }"
          class="inputs"
        >
          <!-- locale -->
          <!-- <a-locale-provider :locale="locale"> -->
          <a-date-picker
            :locale="locale"
            width="100%"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="traintime"
            :disabled-date="disabledDate"
            :disabled-time="disabledDateTime"
            placeholder="选择日期"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
          <!-- </a-locale-provider> -->
        </a-col>
      </a-row>
      <span slot="footer" class="dialog-footer">
        <a-button round class="booksurebtn" type="primary" @click="sureappoint"
          >确 认 预 约</a-button
        >
      </span>
    </a-modal>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Search from "@/components/Search/Search";
import Cardtitle from "@/components/Cardtitle/Cardtitle";
import Cardinfo from "@/components/Cardinfo/Cardinfo";
import Solid from "@/components/Solid/Solid";
import moment from "moment";
import Axios from "@/Axios";
import infoAction from "@/utils";
// import zhCN from '@/ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: "Homepage",
  components: {
    Header,
    Search,
    Cardtitle,
    Cardinfo,
    Solid,
  },
  data() {
    return {
      locale: {
        // lang:{
        //   timeSelect:'选择时间',
        //   dateSelect:'选择日期',
        //   dateFormat: "M/D/YYYY",
        //   dateTimeFormat: "M/D/YYYY HH:mm:ss",
        //   now:'现在时间 ',
        //   ok:'确认'
        // }
        lang: {
          placeholder: "请选择日期",
          rangePlaceholder: ["Start date", "End date"],
          today: "今天",
          now: "现在时间",
          backToToday: "Back to today",
          ok: "Ok",
          clear: "Clear",
          month: "Month",
          year: "Year",
          timeSelect: "选择时间",
          dateSelect: "选择日期",
          monthSelect: "Choose a month",
          yearSelect: "Choose a year",
          decadeSelect: "Choose a decade",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          monthBeforeYear: true,
          previousMonth: "Previous month (PageUp)",
          nextMonth: "Next month (PageDown)",
          previousYear: "Last year (Control + left)",
          nextYear: "Next year (Control + right)",
          previousDecade: "Last decade",
          nextDecade: "Next decade",
          previousCentury: "Last century",
          nextCentury: "Next century",
        },
        timePickerLocale: {
          placeholder: "Select time",
        },
      },
      traintime: "",
      universityname: infoAction.getinfo("universityId_dictText", false),
      input: "",
      url: {
        appoint: "/subscribe/yhaSubscribe/add",
        departlist: "/departments/yhaDepartments/list",
        university: "/university/yhaUniversity/queryById",
        trainlist: "/subscribe/yhaSubscribe/list",
        trainarrange: "/repcomposer/repComposer/report",
        alluniverrecord: "/repcomposer/repComposer/newReport",
      },
      // 测试
      pagination: {
        pageNo: 1,
        pageSize: 5, // 默认每页显示数量
        // showSizeChanger: true, // 显示可改变每页数量
        // pageSizeOptions: ["5", "10", "20", "50", "100"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        // onShowSizeChange: this.onShowSizeChange, // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
      },
      bookinfo: {
        iphone: "",
        orderDate: "",
        universityName: "",
        linkMan: "",
        // departmentName: "",
      },
      departlist: [],
      centerDialogVisible: false,
      columns: [
        {
          dataIndex: "traintime",
          title: "训练时间",
          key: "traintime",
          align: "center",
          ellipsis: true,
        },
        {
          title: "活动编码",
          dataIndex: "activeCode",
          key: "activeCode",
          align: "center",
          ellipsis: true,
        },
        {
          title: "参与部门",
          dataIndex: "traindepartment",
          key: "traindepartment",
          align: "center",
          ellipsis: true,
        },
        {
          title: "参与人数",
          dataIndex: "peoplenum",
          key: "peoplenum",
          align: "center",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
        },
      ],
      tableData: [],
      tableheaderstyle: {
        backgroundColor: "#A6cefd",
      },
    };
  },
  mounted() {
    // 获取单位信息
    this.getunivesity();
    // 获取训练安排
    this.alluniverrecord();
    // 测试需要的预约列表
    // this.gettrainlist();
  },
  methods: {
    moment,
    handleviewdetails(index, data) {},
    // 查看受训人员成绩
    gostuscore() {
      this.$router.push("/searchresult");
    },
    // alluniverrecord
    // 获取训练记录
    gettrainarrange() {
      var data = [];
      Axios.get(this.url.trainarrange, {
        params: {
          // activeCode: infoAction.getinfo("activeCode"),
          activeCode: 0,
          departmentId: 0,
          linkName: infoAction.getinfo("teacher_info").name,
          universityId: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          var allarr = [];
          console.log(records);
          records.map((item, index) => {
            console.log(item.originalData);
            var arr;
            if (item.step == "1" && JSON.parse(item.originalData).length) {
              console.log(item.originalData);
              arr = JSON.parse(item.originalData);
              for (var i = 0; i < arr.length; i++) {
                var obj = {};
                obj.id = item.id;
                obj.departmentId = item.departmentId;
                obj.universityId = item.universityId;
                obj.departmentId_dictText = item.departmentId_dictText;
                obj.universityId_dictText = item.universityId_dictText;
                for (var key in arr[i]) {
                  if (key == "参与人数") {
                    obj.peoplenum = arr[i][key];
                  }
                  if (key == "训练日期") {
                    obj.traintime = arr[i][key];
                  }
                  if (key == "参与部门") {
                    obj.traindepartment = arr[i][key];
                  }
                }
                console.log(obj);
                allarr.push(obj);
              }
            } else {
              // break
            }
          });
          console.log(allarr);
          this.tableData = allarr;
        } else if (res.data.code != 500) {
        }
      });
    },
    // 获取单位训练记录
    alluniverrecord() {
      if (!infoAction.getinfo("teacher_info").universityId) {
        return;
      }
      Axios.get(this.url.alluniverrecord, {
        params: {
          universityId: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          var allarr = [];
          console.log(records);
          records.map((item, index) => {
            console.log(item.originalData);
            var arr;
            if (item.step == "1" && JSON.parse(item.originalData).length) {
              console.log(item.originalData);
              var originalData = JSON.parse(item.originalData)[0];
              var obj = {};
              obj.id = item.id;
              obj.departmentId = item.departmentId;
              obj.universityId = item.universityId;
              obj.departmentId_dictText = item.departmentId_dictText;
              obj.universityId_dictText = item.universityId_dictText;
              obj.peoplenum = originalData.参与人数;
              obj.traintime = originalData.训练日期;
              obj.traindepartment = originalData.参与部门;
              obj.activeCode = item.activeCode;
              allarr.push(obj);
            }
          });
          console.log(allarr);
          this.tableData = allarr;
        } else if (res.data.code != 500) {
        }
      });
    },
    // 获取预约列表
    gettrainlist(pageNo = 1) {
      var that = this;
      Axios.get(this.url.trainlist, {
        params: {
          pageNo: pageNo,
          pageSize: 5,
          universityName: infoAction.getinfo("universityId_dictText", false),
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.result;
          console.log(that.trainlist);
          console.log(result.records);
          that.trainlist = result.records;
          that.pagination.total = result.total;
        }
      });
    },
    // 获取单位信息
    getunivesity() {
      debugger
      Axios.get(this.url.university, {
        params: {
          id: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          infoAction.setinfo("universityinfo", JSON.stringify(res.data.result));
          this.bookinfo.universityName = res.data.result.universityName;
          this.getdepartment(res.data.result.universityCode);
        }
      });
    },
    // 获取学院列表
    getdepartment(universityCode) {
      Axios.get(this.url.departlist, {
        params: {
          pageNo: 1,
          pageSize: 100,
          universityId: universityCode,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.result;
          this.departlist = result.records;
        }
      });
    },
    // 确认预约
    sureappoint() {
      if (this.traintime) {
        this.bookinfo.orderDate = this.traintime;
      } else {
        this.$message.warning("请选择训练时间");
        return;
      }
      if (!this.bookinfo.linkMan) {
        this.$message.warning("请输入联系人");
        return;
      }
      var iphonereg = new RegExp(/^1[3456789]\d{9}$/);
      if (!iphonereg.test(this.bookinfo.iphone)) {
        console.log(this.bookinfo.iphone);
        this.$message.warning("手机号码格式匹配，请重新输入");
        return;
      }

      Axios.post(this.url.appoint, this.bookinfo).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("预约成功");
          this.gettrainlist();
        }
      });
      this.centerDialogVisible = false;
    },
    // 取消预约框
    closeappoint() {
      this.centerDialogVisible = false;
    },
    // 训练安排查看详情
    seedetails(data) {
      // console.log(data);
      this.$router.push({
        path: "/traindetails",
        query: {
          id: data.id,
          time: data.traintime,
          numofman: data.peoplenum,
          activeCode: data.activeCode,
          departmentId: data.departmentId,
          universityId: data.universityId,
          departmentId_dictText: data.departmentId_dictText,
          universityId_dictText: data.universityId_dictText,
        },
      });
    },
    // 部门改变
    handdepartChange() {},
    // 时间选择方法
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },
    disabledDateTime() {
      return {
        disabledHours: () => [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          12,
          13,
          19,
          20,
          21,
          22,
          23,
        ],
        // disabledHours: () => this.range(17,24).splice(17,9),
        disabledMinutes: () => this.range(),
        disabledSeconds: () => [],
      };
    },
    onPageChange(page) {
      console.log(page);
      // this.pagination.pageNo = page;
      this.pagination.current = page;
      this.gettrainlist(page);
    },
  },
};
</script>
<style scoped>
.leftpadding {
  box-sizing: border-box;
  padding: 50px 3vw;
}
.solid {
  height: 20px;
  /* background-color: #f0f2f5; */
}
.crumbs {
  box-sizing: border-box;
  padding: 30px 0 0 0;
  border-bottom: 2px solid #f0f2f5;
}
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
/* .float{
  float: left;
} */
.titleText {
  margin-top: 3vh;
  font-weight: bold;
  border-left: 5px solid blueviolet;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
/* .cardbox {
  display: flex;
  justify-content: flex-start;
} */
.bookbox {
  height: 8vh;
  display: flex;
  /* margin-top: 30px; */
  justify-content: center;
  align-items: center;
}
.bookbtn {
  box-shadow: 1px 4px 13px 0px rgba(25, 50, 100, 0.29);
}
.tablebox {
  box-shadow: 0px 4px 24px 0px rgba(45, 44, 44, 0.17);
  margin-top: 2vh;
  margin-bottom: 10vh;
}
.inputtext {
  text-align: right;
}
.inputbar {
  margin-bottom: 3vh;
}
.booksurebtn {
  width: 50%;
}
.icon {
  margin-right: 1vw;
}
/* .departselect::webkit-scrollbar { 
   display: none;
}
.depart::webkit-scrollbar { 
   display: none;
} */
/* @media screen and (max-width: 768px) {

} */
</style>



// WEBPACK FOOTER //
// src/views/homepage/Homepage.vue